import React from 'react';

const DownArrow = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <g fill={color}>
        <g>
          <g>
            <g>
              <path
                d="M7.092 18.964L17.424 8.66 17.424 16.612 18.936 16.612 18.936 6 8.296 6 8.296 7.54 16.332 7.512 6 17.844z"
                transform="translate(-176 -1723) translate(0 263) translate(72 1332) translate(104 128) rotate(135 12.468 12.482)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default DownArrow;
